import { useAppDispatch } from 'src/Hooks/redux'
import {
  setTiktokTracksToInitialState,
  setTiktokTrackToInitialState,
} from 'src/Redux/tiktokTrack-process'

export const useCreateCampaignLayout = (): {
  resetSearchTracksToInitialState: () => void
} => {
  const dispatch = useAppDispatch()

  const resetSearchTracksToInitialState = (): void => {
    dispatch(setTiktokTracksToInitialState())
    dispatch(setTiktokTrackToInitialState())
  }

  return {
    resetSearchTracksToInitialState,
  }
}
